export default __webpack_public_path__ + "static/wheelsIcon-bd873700609f003d4c74c424c02f9528.jpeg";